// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".errorBoundary__container___eGdoT{height:100%;width:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;padding:10px}.errorBoundary__alertIcon___28a5H{font-size:12px;color:#717070;width:30px}.errorBoundary__header___12bgG{color:#222;font-weight:500;margin:20px;font-size:16px}.errorBoundary__subHeader___3Un1k{color:#717070}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "calc(100% - 30px)",
	"widgetFrameMaxHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"container": "errorBoundary__container___eGdoT",
	"alertIcon": "errorBoundary__alertIcon___28a5H",
	"header": "errorBoundary__header___12bgG",
	"subHeader": "errorBoundary__subHeader___3Un1k"
};
export default ___CSS_LOADER_EXPORT___;
